// extracted by mini-css-extract-plugin
module.exports = {"container":"_2nnLyS8pju","message":"_17gxkvagqf"};
    if(module.hot) {
      // 1614934757103
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  